const e = {
  name: "CreditcardSelectionFilled",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.13857 6.44322L17.2776 2.51348C17.8138 2.36464 18.3777 2.68656 18.5206 3.23557L19.2609 6.21179L21.2018 5.72899L20.4604 2.74856L20.4585 2.74116C20.0401 1.11217 18.365 0.135711 16.7422 0.586485L2.60137 4.51671C1.03652 4.95306 0.110216 6.55912 0.499277 8.13033L1.06638 10.3717C1.0229 10.5744 1 10.7846 1 11V12H23V11C23 9.34768 21.6523 7.99997 20 7.99997H4C3.50109 7.99997 3.02996 8.12284 2.61531 8.33988L2.44066 7.6496L2.44016 7.64757C2.31056 7.1196 2.62436 6.58687 3.13857 6.44322Z" fill="currentColor"/>
<path d="M1 20V14H23V20C23 21.6523 21.6523 23 20 23H4C2.34772 23 1 21.6523 1 20ZM9 17H5V19H9V17Z" fill="currentColor"/>
</svg>
  `
};
export {
  e as CreditcardSelectionFilled
};
